/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-loop-func */
import React, { useState, useEffect } from 'react'
import _ from 'lodash';
var CryptoJS = require("crypto-js");

var datesToSend = {}
var vehicleMap = {}
var dateIdMap = {}
var outsideDriver = null
var outsideDate = new Date()
var submitBool = true

// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
    var firstDate = new Date(this.getFullYear(), 0, 1)
    if (this.getFullYear() === 2021) {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
    } else {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
    }
}

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            if (new Date(offboradedContent).getWeek() - 1 < new Date(selectedFunctionDate).getWeek()) {
                return false
            } else {
                return true
            }
    }
}


const RentalVanTrackerComponent = (props) => {
    // eslint-disable-next-line no-extend-native
    // state from props
    const [ drivers, setDrivers ] = useState([])
    const [ dates, setDates ] = useState([])
    const [ vehicles, setVehicles ] = useState([])
    const [ dateArray, setDateArray ] = useState([])

    // mapped state for use
    const [ sortedDriversToDates, setSortedDriversToDates] = useState([])

    // final render array
    const [ renderArray, setRenderArray ] = useState([])

    // state for handling the registration inputs
    const [ switchVisibilityTwo, setSwitchVisibilityTwo ] = useState('otherFuckMeClass')

    // state for registration list
    const [ registrations, setRegistrations ] = useState([])

    // driver for selecting the registration
    const [ selectedDriver, setSelectedDriver ] = useState(null)

    // alphabetical search for registrations
    const [ registrationSearch, setRegistrationSearch ] = useState([])

    // select registration state
    const [ registrationSelectionScreen, setRegistrationSelectionScreen ] = useState(null)

    // gate for registration list screen
    const [ registrationGate, setRegistrationGate] = useState(false)

    // error screen
    const [ errorScreen, setErrorScreen ] = useState(null)

    // grab the data from parent component
    useEffect( () => {
        if (props.drivers) {
            setDrivers(props.drivers)
        } 
        if (props.dateArray) {
            setDateArray(props.dateArray)
        }
        if (props.dates) {
            setDates(props.dates)
        }
        if (props.vehicleData) {
            setVehicles(props.vehicleData)
        }
        if (props.sunday) {
            outsideDate=props.sunday
        }
    }, [props])

    // react lifecycyle
    useEffect( () => {
        outsideDriver = selectedDriver
    }, [selectedDriver])

    // map the registrations to the list
    useEffect( () => {
        if (drivers && vehicles) {
            // // array for making sure no duplicates
            // let alreadyAssignedArray = []

            // array of registrations for state
            let finalRegList = []

            // // driver check
            // drivers.forEach( driver => {
            //     if (driver.vehicle_name !== null) {
            //         alreadyAssignedArray.push(driver.vehicle_name)
            //     }
            // })

            // // vehicles check
            // vehicles.forEach( vehicle => {
            //     if (!alreadyAssignedArray.includes(vehicle.registration)) {
            //         finalRegList.push(vehicle.registration)
            //     }
            // })
            vehicles.forEach( vehicle => {
                if (!vehicle.offboarded) {
                    finalRegList.push({
                        reg: vehicle.registration,
                        type: vehicle.vtype
                    })
                }
            })

            // set the local array to state
            setRegistrations(finalRegList)
        }
        if (vehicles) {
            vehicles.forEach( vehicle => {
                vehicleMap[vehicle.registration] = {
                    reg: vehicle.vehicle_id,
                    type: vehicle.vtype
                }
            })
        }

    }, [drivers, vehicles])

    // make the component
    useEffect( () => {
        // map the data
        // array for the drivers that have been assigned a registration
        if (drivers !== undefined && dates !== undefined) {

            // array for rendering the drivers
            let driversMappedArray = []

            // array for the drivers
            let driversArray = []

            // add the drivers to the array
            drivers.forEach( ele => {
                if (ele.SigningUrlNumber !== null && ele.location === props.selectedCity && !ele.rentalCheckList.includes(new Date(props.sunday).toDateString()) && determineOffboarded(ele.status, props.sunday)) {
                    driversArray.push(ele)
                }
            })

            // sort the drivers
            driversArray.sort((firstEle, secondEle) => (firstEle.name.toLowerCase() > secondEle.name.toLowerCase()) ? 1 : -1)

            // make an array for rendering
            driversArray.forEach( (driver, vanID) => {
                // make temporary array to house new data
                let driverMappedDates = []

                // array of ojbects for use in deletiongit add -A
                let dateObj = []

                // add dates for the driver to the correct driver
                dates.forEach( date => {
                    if (parseInt(date.driver_id.match(/\d+/g)[0]) === driver.driver_id) {
                        driverMappedDates.push(date.date)
                        dateObj.push(date)
                    }
                })
                driver.datesList = driverMappedDates
                driver.datesWithid = dateObj
            })

            // set the mapped data in the state
            setSortedDriversToDates(driversArray)
        }
    }, [drivers, dates, props.selectedCity, props.sunday])

    // function for selecting date
    const handleSelectDate = (e, localSelectedDate, selectedLocalDriver) => {
        let registrationToDisplay = ''
        let newCodeBool = false
        selectedLocalDriver.vehicle_list.forEach( reg => {
            if (reg.includes('+')) {
                let dateToCheck = reg.split('+')[1]
                if (new Date(dateToCheck).toDateString() === new Date(outsideDate).toDateString()) {
                    registrationToDisplay = reg.split('+')[0]
                    newCodeBool = true
                }
            }
        })
        if (!newCodeBool) {
            registrationToDisplay = selectedLocalDriver.vehicle_name
        }
        if (datesToSend[selectedLocalDriver.driver_id]) {
            if (registrationToDisplay) {
                datesToSend[selectedLocalDriver.driver_id].dates.push(localSelectedDate)
            }
        } else {
            if (registrationToDisplay) {
                datesToSend[selectedLocalDriver.driver_id] = {
                    'dates': [localSelectedDate],
                    'vehicle': registrationToDisplay
                }
            }
        }
    }

    // submitting function for adding registration to driver
    const handleSubmitVan = (e, registrationToSubmit) => {
        // post function
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')

        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')

        };
        let arrayToPush = []
        if (typeof outsideDate === typeof new Date()) {
            arrayToPush = [...outsideDriver.vehicle_list, `${registrationToSubmit.props.children}+${outsideDate.toDateString()}`]
        } else {
            arrayToPush = [...outsideDriver.vehicle_list, `${registrationToSubmit.props.children}+${outsideDate}`]
        }
        // console.log(arrayToPush)
        if (outsideDriver.vehicle_name) {
            postData(`https://backendpajamas.herokuapp.com/driverhistory/`, {
                vehicle_id: outsideDriver.vehicle_name
            }).then(response => {
                if (response.data.length > 0) {
                    response.data.forEach( driverHistory => {
                        if (parseInt(driverHistory.driver_id) === outsideDriver.driver_id) {
                            if (!driverHistory.endDate) {
                                putData(`https://backendpajamas.herokuapp.com/driveraddhistory/${driverHistory.DriverHistory_id}/`, {
                                    endDate: new Date().toDateString()
                                })
                            }
                        }
                    })
                }
            })
        }
        putData(`https://backendpajamas.herokuapp.com/drivers/${outsideDriver.driver_id}/`, {
            vehicle_name: registrationToSubmit.props.children,
            vehicle_list: arrayToPush
        }).then( (responseDriver) => {
            props.reloadTheDrivers()
            setRegistrationGate(false)
            let dateToSubmit = ''
            let weekToSubmit = ''
            if (typeof outsideDate === typeof new Date()) {
                dateToSubmit = outsideDate.toDateString()
                weekToSubmit = outsideDate.getWeek()
            } else {
                dateToSubmit = outsideDate
                weekToSubmit = new Date(outsideDate).getWeek()
            }
            postData('https://backendpajamas.herokuapp.com/driveraddhistory/', {
                date: dateToSubmit,
                week_number: weekToSubmit,
                driver_id: outsideDriver.driver_id,
                registration: registrationToSubmit.props.children,
                name: outsideDriver.name
            })
        })
    }

    ////////////////////////////////////// registration mapping section
    // takes an input of a leter and sets the array to the according list
    const handleChange= (e) => {
        setRegistrationSearch(mapTheOption(mapRegistrations(e.target.value)))
    }

    // takes a letter and sorts the list for it
    const mapRegistrations = (letters) => {
        var registrationList = []
        if (letters) {
            registrations.forEach( registration => {
                if (registration.reg.includes(letters)) {
                    registrationList.push(
                        <div className='rentalVanChildName'>{registration.reg}</div>
                    )
                }
            })
        } else {
            registrations.forEach( registration => {
                registrationList.push(
                    <div className='rentalVanChildName'>{registration.reg}</div>
                )
            })
        }
        return registrationList
    }
    
    // function for mapping 
    const mapTheOption = (theList) => {
        let localArray = []
        theList.forEach( (option, optionID) => {
            localArray.push(
                <li className='registrationSearchList' onClick={(e, theOption) => handleSubmitVan(e, option)}>
                    {option}
                </li>
            )
        })
        return localArray
    }
    
    ////////////////////////////////////// registration mapping section end
    ////////////////////////////////////// Submit the dates selected ////////////////
    // handle the form submit
    const handleSubmitLodash = (e) => {
        e.preventDefault()
        if (submitBool === true) {
            handleSubmittingReal()
            submitBool = false
            setTimeout( () => {
                submitBool = true
            }, 2000)
        }
    }

    const handleSubmittingReal = () => {
        // setErrorScreen(
        //     <div className='submittingForRentalVanTracker'>
        //         <h3>Submitting</h3>
        //     </div>
        // )
        // post function
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        async function postData(url = '', data = {}) {
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')

        };
        for (let key in datesToSend) {

            datesToSend[key].dates.forEach( element => {
                postData(`https://backendpajamas.herokuapp.com/vanDates/`, {
                    vehicle_id: `https://backendpajamas.herokuapp.com/vehicles/${vehicleMap[datesToSend[key].vehicle].reg}/`, 
                    driver_id: `https://backendpajamas.herokuapp.com/drivers/${key}/`,
                    date: element,
                    week_number: new Date(element).getWeek(),
                    location: props.selectedCity,
                    registration: datesToSend[key].vehicle,
                    manager_id: props.userId,
                    vtype: vehicleMap[datesToSend[key].vehicle].type
                }).then( (response) => {
                    if (response.vehicle_id) {
                        if (response.vehicle_id[0] === "Invalid hyperlink - Object does not exist.") {
                            setErrorScreen(
                                <div className='regDoesNotExist'>
                                    <h3>Van Reg does not exist, please change the registration</h3>
                                </div>
                            )
                            setTimeout( () => {
                                setErrorScreen(null)
                            }, [2000])
                        }
                    }
                    props.reloadDatesProp(props.currentDate)
                    datesToSend={}
                })
            })
            // setTimeout( () => {
            //     setErrorScreen(null)
            // }, 1000)
        }
        // setTimeout(() => {
        //     setErrorScreen(null)

        // }, 2000)
    }

    // NV67PBF

    // remove the error screen
    const handleRemoveErrorScreen = () => {
        setErrorScreen(null)
    }

    // handle making error screen
    const handleRemoveDriver = (e, theDriver) => {
        setErrorScreen(
            <div className='errorScreenRentalVanTracker'>
                Are you sure you want to remove?
                <div>
                    <button onClick={() => handleRemoveDriverActual(e, theDriver)}>Yes</button>
                    <button onClick={handleRemoveErrorScreen}>No</button>
                </div>
            </div>
        )
    }

    // function for removing the driver
    const handleRemoveDriverActual = (e, theDriver) => {
        // post function
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')

        };
        // delete function
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
            });

        };

        props.dates.forEach( date => {
            if (date.driver_id === `https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`) {
                deleteData(`https://backendpajamas.herokuapp.com/vanDates/${date.vehicleDate_id}/`)
            }
        })
        let localRentalArray = [...theDriver.rentalCheckList]
        localRentalArray.push(new Date(outsideDate).toDateString())

        postData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
            rentalCheckList: localRentalArray
        }).then( (response) => {
            props.reloadTheDrivers()
            props.reloadDatesProp(props.currentDate)
            setRegistrationGate(false)
            setErrorScreen(null)
        })
    }


    ////////////////////////////////////// Submit the dates selected end ////////////////
    // make the stuff visible
    const handleClick = () => {
        setSwitchVisibilityTwo('noVisibility')
    }

    // delete the day
    const handleDeleteDay = (e, theLocalDate,  driverVehicle, dayDetails, driverDetails) => {
        props.handleDeleteDayProp(e, theLocalDate, props.currentDate, driverVehicle, dayDetails, driverDetails)
    }

    // handle selecting a driver for adding the registration
    const handleSelectDriver = (e, theMappedDriver) => {
        setSelectedDriver(theMappedDriver)
    }

    // handle toggling the select a registration
    const handleRegistrationClick = (e, theMappedDriver) => {
        setRegistrationGate(true)
        setSelectedDriver(theMappedDriver)
    }

    // return form the registration page
    const handleReturn = () => {
        setRegistrationGate(false)
        setRegistrationSelectionScreen(null)
    }

    // allow for editing state
    useEffect( () => {
        if (registrationGate && selectedDriver) {
            setRegistrationSelectionScreen(
                <div className='registrationSelectiongScreen'>
                    <div className='vanRegContent'>
                        <h3>Please select a van registration for: {selectedDriver.name}</h3>
                        <h4>Type any letter to search registrations</h4>
                        <input 
                            type="text"  
                            className='inputRentalVanTracker'
                            placeholder='Ex: a'
                            onChange={handleChange}
                        />
                        <ol className='listRentalVanCheck'>
                            {registrationSearch}
                        </ol>
                        <button 
                            className='compliance_add_driver_button_submit' 
                            id='registrationReturnButton'
                            onClick={handleReturn}
                        >
                            Return
                        </button>
                    </div>
                </div>
            )
        } else {
            setRegistrationSelectionScreen(null)
        }
    }, [registrationSearch, registrationGate])

    // map the data to the render array
    useEffect( () => {
        // render array
        let renderArray = []
        sortedDriversToDates.forEach( driver => {
            let registrationToDisplay = ''
            let newCodeBool = false
            driver.vehicle_list.forEach( reg => {
                if (reg.includes('+')) {
                    let dateToCheck = reg.split('+')[1]
                    if (new Date(dateToCheck).toDateString() === new Date(outsideDate).toDateString()) {
                        newCodeBool = true
                        registrationToDisplay = reg.split('+')[0]
                    }
                }
            })
            if (!newCodeBool) {
                registrationToDisplay = driver.vehicle_name
            }
            let totalCount = 0
            let localArray = []
            localArray.push(
                <>
                    <div className='overallNameInputDivRental'>
                        <div className='removeDriverFromRentalVanTracker' onClick={(e, theDriver) => handleRemoveDriver(e, driver)}>x</div>
                        <input type='submit' value={driver.name} className='van_vertical_name' />
                        <p className='pTagRentalVehicle'>Submit</p>
                    </div>   
                    <div className='van_vertical_weekday_registration' >
                        <div 
                            onClick={(e, driverteo) => handleRegistrationClick(e, driver)}
                            className={switchVisibilityTwo}
                        >
                            
                            {registrationToDisplay}
                        </div>
                    </div>
                </>
            )
            dateArray.forEach( date => {
                if (driver.datesList.includes(date)) {
                    totalCount++
                    if (driver.datesWithid[driver.datesList.indexOf(date)]) {
                        if (driver.datesWithid[driver.datesList.indexOf(date)].registration !== "DBS2" && driver.datesWithid[driver.datesList.indexOf(date)].registration !== registrationToDisplay) {
                            localArray.push(
                                <div className='van_vertical_weekday_five' onClick={(e) => handleDeleteDay(e, date, driver.datesWithid[driver.datesList.indexOf(date)].vehicleDate_id, driver.datesWithid[driver.datesList.indexOf(date)], driver)}>
                                    <h3 className='innerNumber'>1</h3>
                                    <div className='hoverDisplay'>
                                        <h3 >{driver.datesWithid[driver.datesList.indexOf(date)].registration}</h3>
                                    </div>
                                </div>
                            )
                        }
                        else {
                            localArray.push(
                                <div className='van_vertical_weekday_three' onClick={(e) => handleDeleteDay(e, date, driver.datesWithid[driver.datesList.indexOf(date)].vehicleDate_id, driver.datesWithid[driver.datesList.indexOf(date)], driver)}>
                                    <h3 className='innerNumber'>1</h3>
                                    <div className='hoverDisplay'>
                                        <h3 >{driver.datesWithid[driver.datesList.indexOf(date)].registration}</h3>
                                    </div>
                                </div>
                            )
                        }
                    }
                } else {
                    localArray.push(
                        <div className='van_vertical_weekday_two'>
                            <label className='container_checkbox_two'>
                                {/* <div className='innerPlacementDivRental'> */}
                                    <input type="checkbox" onClick={(e) => handleSelectDate(e, date, driver)}/>
                                    <span className='checkmark_yes_two' id='yes'></span>

                                {/* </div> */}
                            </label>
                        </div>
                    )
                }
            })
            localArray.push(
                <div className='van_vertical_weekday_four'>
                    {totalCount}
                </div>
            )
            renderArray.push(localArray)
        })

        // set local array to state
        setRenderArray(renderArray)
    }, [sortedDriversToDates, switchVisibilityTwo, registrationSearch, props.sunday])

    return (
        <form onSubmit={handleSubmitLodash}>
            {errorScreen}
            {registrationSelectionScreen}
            <div className='van_Horizontal' >
                {renderArray}
            </div>
        </form>
    )
}

export default RentalVanTrackerComponent
